module.exports = __webpack_public_path__ + "img/208.78c5f2c9.jpg";